import { contractOperatorLand, contractColonyNft } from './contract';

export const stake = async (eth, account, tokensId, cbSuccess = () => {}, cbError = () => {}) => {
  const operatorLandContract = new eth.Contract(
    contractOperatorLand.abi,
    contractOperatorLand.address,
  );

  const colonyNftContract = new eth.Contract(
    contractColonyNft.abi,
    contractColonyNft.address,
  );

  const addressOperator = process.env.REACT_APP_OPERATOR_LANDS_CONTRACT_ADDRESS;

  const isApprovedForAll = await colonyNftContract.methods.isApprovedForAll(account, addressOperator).call();
  if (isApprovedForAll === false) {
    colonyNftContract.methods.setApprovalForAll(addressOperator, true).send({ from: account })
      .then(async () => {
        operatorLandContract.methods.batchStakeX2NFT(tokensId).send({ from: account })
          .then((elem) => {
            cbSuccess(elem);
          })
          .catch((error) => {
            cbError(error);
          });
      })
      .catch((error) => { cbError(error); });
  } else {
    operatorLandContract.methods.batchStakeX2NFT(tokensId).send({ from: account })
      .then((elem) => {
        cbSuccess(elem);
      })
      .catch((error) => {
        cbError(error);
      });
  }
};

export const unstake = async (eth, account, tokensId, cbSuccess = () => {}, cbError = () => {}) => {
  const operatorLandContract = new eth.Contract(
    contractOperatorLand.abi,
    contractOperatorLand.address,
  );

  const colonyNftContract = new eth.Contract(
    contractColonyNft.abi,
    contractColonyNft.address,
  );
  const addressOperator = process.env.REACT_APP_OPERATOR_LANDS_CONTRACT_ADDRESS;

  const isApprovedForAll = await colonyNftContract.methods.isApprovedForAll(account, addressOperator).call();

  if (isApprovedForAll === false) {
    colonyNftContract.methods.setApprovalForAll(addressOperator, true).send({ from: account })
      .then(async () => {
        operatorLandContract.methods.batchUnstakeX2NFT(tokensId).send({ from: account })
          .then((elem) => {
            cbSuccess(elem);
          })
          .catch((error) => {
            cbError(error);
          });
      })
      .catch((error) => { cbError(error); });
  } else {
    operatorLandContract.methods.batchUnstakeX2NFT(tokensId).send({ from: account })
      .then((elem) => {
        cbSuccess(elem);
      })
      .catch((error) => {
        cbError(error);
      });
  }
};
